import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutePermissionResolver } from '@app/@core/router/route-permission.resolver';
import { MastersComponent } from './masters/masters.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { RbacComponent } from './rbac.component';
import { UsersComponent } from './users/users.component';
import { MigrateUserComponent } from './migrateuser/migrateuser.component';

const routes: Routes = [
  {
    path: '',
    component: RbacComponent,
    children: [
      { path: 'users', component: UsersComponent },
      { path: 'migrateuser', component: MigrateUserComponent },
      { path: 'masters', component: MastersComponent },
      { path: 'page-permissions', component: PermissionsComponent },
      // { path: 'organization', component: ManagementGroupsComponent },
      {
        path: 'groups-roles',
        loadChildren: () => import('@app/pages/rbac/groups-roles/groups-roles.module').then(m => m.GroupsRolesModule),
        data: {
          rootmodulenames: ['SETTINGS'],
          route: '/rbac'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'page-access-list',
        loadChildren: () => import('./access-management/page-access/page-access.module').then(m => m.PageAccessModule)
      },
      {
        path: 'page-access',
        loadChildren: () => import('./access-management/page-access/page-access.module').then(m => m.PageAccessModule)
      },
      {
        path: 'config-dashboard',
        loadChildren: () =>
          import('../rbac/config-dashboard/config-dashboard.module').then(m => m.ConfigDashboardModule)
      },
      {
        path: 'config-dashboard-user',
        loadChildren: () =>
          import('../config-dashboard-user/config-dashboard-user.module').then(m => m.ConfigDashboardUserModule)
      },
      // {
      //   path: 'configure-settings',
      //   loadChildren: () =>
      //     import('./configure-settings/configure-settings.module').then(m => m.ConfigureSettingsModule)
      // },
      { path: '**', redirectTo: 'users', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RbacRoutingModule {}
